import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

/**
 * StatCard - Individual statistic display card (MIGRATED VERSION)
 *
 * Renders a single statistic with label and value using a clean, minimal design.
 * Matches the cohesive design of the original StatCard component.
 *
 * @param {Object} props - Component props
 * @param {string} props.label - The label text for the statistic
 * @param {string|number} props.value - The value to display
 * @param {boolean} [props.bordered] - Whether to show left/right borders
 * @param {string} [props.className] - Additional CSS classes
 *
 * @returns {JSX.Element} Statistic card with label and value
 */
const StatCard = forwardRef(({
	label,
	value,
	bordered = false,
	className,
	...props
}, ref) => {
	const borderClass = bordered
		? "border-l border-r border-input px-8"
		: "px-4";

	return (
		<div
			ref={ref}
			className={cn(
				borderClass,
				"flex flex-col items-center gap-4 py-10",
				className
			)}
			{...props}
		>
			<span className="text-base font-regular">{label}</span>
			<span className="text-4xl font-bold">{value}</span>
		</div>
	);
});

StatCard.displayName = "StatCard";

export { StatCard };



